var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex-1" }, [
    _c("div", { ref: "progressContainer" }, [
      _c(
        "div",
        { staticClass: "overflow-x-auto no-scrollbar overflow-hidden" },
        [
          _c(
            "div",
            {
              staticClass:
                "flex items-center px-12 pt-6 relative transition-transform duration-500 ease-in-out",
              style: {
                transform: `translateX(-${
                  _vm.visibleRange.start ? _vm.visibleRange.start * 25 : 10
                }%)`,
              },
            },
            [
              _vm._l(_vm.steps, function (step, index) {
                return [
                  _c(
                    "div",
                    {
                      key: index,
                      ref: index === _vm.currentStep ? "currentStep" : null,
                      refInFor: true,
                      staticClass:
                        "flex-shrink-0 w-1/4 flex flex-col items-center relative z-10",
                    },
                    [
                      _c("div", { staticClass: "flex items-center" }, [
                        _c("div", {
                          class: [
                            "h-1 w-24",
                            index > 0 ? "" : "hide-bg",
                            _vm.isStepComplete(index) &&
                            _vm.isStepComplete(index - 1)
                              ? "bg-primary"
                              : "bg-gray-200",
                          ],
                        }),
                        _c(
                          "div",
                          {
                            class: [
                              "number-badge",
                              _vm.currentStep === index
                                ? "bg-primary text-white"
                                : _vm.isStepComplete(index)
                                ? "bg-steps-light-blue text-primary-black"
                                : "bg-gray-200 text-gray-600",
                            ],
                          },
                          [
                            _vm.isStepComplete(index)
                              ? [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "10",
                                        height: "8",
                                        viewBox: "0 0 10 8",
                                        fill: "none",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M9.34884 0.5H8.58888C8.48234 0.5 8.38122 0.548924 8.31599 0.63264L3.83343 6.31114L1.68401 3.58768C1.6515 3.54639 1.61005 3.51301 1.56279 3.49004C1.51553 3.46707 1.46367 3.4551 1.41112 3.45504H0.651163C0.57832 3.45504 0.538093 3.53875 0.582669 3.59529L3.56054 7.3679C3.6997 7.54403 3.96715 7.54403 4.1074 7.3679L9.41734 0.639163C9.46191 0.583715 9.42168 0.5 9.34884 0.5Z",
                                          fill: "#070823",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              : [_vm._v(" " + _vm._s(index + 1) + " ")],
                          ],
                          2
                        ),
                        _c("div", {
                          class: [
                            "h-1 w-24",
                            index < _vm.steps.length - 1 ? "" : "hide-bg",
                            _vm.isStepComplete(index) &&
                            _vm.isStepComplete(index + 1)
                              ? "bg-primary"
                              : "bg-gray-200",
                          ],
                        }),
                      ]),
                      _c(
                        "span",
                        {
                          staticClass: "text-sm mt-2 text-center",
                          class: [
                            _vm.currentStep === index
                              ? "text-primary font-medium"
                              : _vm.isStepComplete(index)
                              ? "text-primary-black font-medium"
                              : "text-gray-500",
                          ],
                        },
                        [_vm._v(" " + _vm._s(step.title) + " ")]
                      ),
                    ]
                  ),
                ]
              }),
            ],
            2
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "flex-1" },
        [
          _vm.currentStep === 0
            ? _c("RequiredServices", {
                attrs: { formData: _vm.localFormData },
                on: {
                  "update:formData": _vm.handleFormDataUpdate,
                  "save-draft": _vm.handleSaveDraft,
                },
              })
            : _vm._e(),
          _vm.currentStep === 1
            ? _c("EmergencyContact", {
                attrs: { formData: _vm.localFormData },
                on: {
                  "update:formData": _vm.handleFormDataUpdate,
                  "save-draft": _vm.handleSaveDraft,
                },
              })
            : _vm._e(),
          _vm.currentStep === 2
            ? _c("LanguageCommunication", {
                attrs: { formData: _vm.localFormData },
                on: {
                  "update:formData": _vm.handleFormDataUpdate,
                  "save-draft": _vm.handleSaveDraft,
                },
              })
            : _vm._e(),
          _vm.currentStep === 3
            ? _c("HealthInformation", {
                attrs: { formData: _vm.localFormData },
                on: {
                  "update:formData": _vm.handleFormDataUpdate,
                  "save-draft": _vm.handleSaveDraft,
                },
              })
            : _vm._e(),
          _vm.currentStep === 4
            ? _c("FunctionalAssessment", {
                attrs: { formData: _vm.localFormData },
                on: {
                  "update:formData": _vm.handleFormDataUpdate,
                  "save-draft": _vm.handleSaveDraft,
                },
              })
            : _vm._e(),
          _vm.currentStep === 5
            ? _c("PersonalConsiderations", {
                attrs: { formData: _vm.localFormData },
                on: {
                  "update:formData": _vm.handleFormDataUpdate,
                  "save-draft": _vm.handleSaveDraft,
                },
              })
            : _vm._e(),
          _vm.currentStep === 6
            ? _c("SupportNetwork", {
                attrs: { formData: _vm.localFormData },
                on: {
                  "update:formData": _vm.handleFormDataUpdate,
                  "save-draft": _vm.handleSaveDraft,
                },
              })
            : _vm._e(),
          _vm.currentStep === 7
            ? _c("CareGoals", {
                attrs: { formData: _vm.localFormData },
                on: {
                  "update:formData": _vm.handleFormDataUpdate,
                  "save-draft": _vm.handleSaveDraft,
                },
              })
            : _vm._e(),
          _vm.currentStep === 8
            ? _c("AdditionalNotes", {
                attrs: { formData: _vm.localFormData },
                on: {
                  "update:formData": _vm.handleFormDataUpdate,
                  "save-draft": _vm.handleSaveDraft,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "flex mt-6",
          class: _vm.currentStep > 0 ? "justify-between" : "justify-end",
        },
        [
          _vm.currentStep > 0
            ? _c("UIButton", {
                attrs: {
                  size: "sm",
                  variant: "outline",
                  buttonText: "Previous",
                },
                on: { click: _vm.handlePrev },
              })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "flex space-x-4" },
            [
              _vm.isDrafted === "null" || _vm.isDrafted === true
                ? [
                    _c("UIButton", {
                      attrs: {
                        variant: "outline",
                        disabled: _vm.invalid,
                        size: "sm",
                        buttonText: "Save as draft",
                      },
                      on: { click: _vm.saveDraft },
                    }),
                    _c("UIButton", {
                      attrs: {
                        variant: "primary",
                        disabled: _vm.invalid,
                        size: "sm",
                        buttonText: _vm.isLastStep ? "Create" : "Next",
                      },
                      on: {
                        click: function ($event) {
                          _vm.isLastStep
                            ? _vm.$emit("submit")
                            : _vm.handleNext()
                        },
                      },
                    }),
                  ]
                : _vm.isDrafted === false
                ? [
                    _c("UIButton", {
                      attrs: {
                        variant: "primary",
                        disabled: _vm.invalid,
                        size: "sm",
                        buttonText: "Update",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("submit")
                        },
                      },
                    }),
                    !_vm.isLastStep
                      ? _c("UIButton", {
                          attrs: {
                            variant: "primary",
                            disabled: _vm.invalid,
                            size: "sm",
                            buttonText: "Next",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handleNext()
                            },
                          },
                        })
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }